(function () {
  'use strict';

  function setupHero() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
    var index = 0;
    var timer;

    function render(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      slider.dataset.heroIndex = String(index);
    }

    function restartTimer() {
      window.clearInterval(timer);
      timer = window.setInterval(function () { render(index + 1); }, 6500);
    }

    var previous = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    if (previous) previous.addEventListener('click', function () { render(index - 1); restartTimer(); });
    if (next) next.addEventListener('click', function () { render(index + 1); restartTimer(); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { render(Number(dot.dataset.heroDot)); restartTimer(); }); });
    slider.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    slider.addEventListener('mouseleave', restartTimer);
    render(0);
    restartTimer();
  }

  function setupCoreCarousel() {
    var carousel = document.querySelector('[data-core-carousel]');
    if (!carousel) return;
    var viewport = carousel.querySelector('.core-viewport');
    var track = carousel.querySelector('.core-track');
    var cards = Array.prototype.slice.call(carousel.querySelectorAll('.core-card'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-core-dot]'));
    var index = 1;
    var timer;
    var resizeFrame;
    var autoplayDelay = 7200;

    function render(nextIndex) {
      index = (nextIndex + cards.length) % cards.length;
      var cardWidth = cards[0] ? cards[0].getBoundingClientRect().width : 0;
      var viewportWidth = viewport.getBoundingClientRect().width;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0') || 0;
      var offset = ((viewportWidth - cardWidth) / 2) - (index * (cardWidth + gap));
      track.style.paddingLeft = '0px';
      track.style.paddingRight = '0px';
      track.style.transform = 'translateX(' + offset + 'px)';
      cards.forEach(function (card, cardIndex) {
        var active = cardIndex === index;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
      carousel.dataset.coreIndex = String(index);
    }

    var previous = carousel.querySelector('[data-core-prev]');
    var next = carousel.querySelector('[data-core-next]');
    function pauseTimer() { window.clearInterval(timer); }
    function restartTimer() {
      pauseTimer();
      timer = window.setTimeout(function advance() {
        render(index + 1);
        timer = window.setTimeout(advance, autoplayDelay);
      }, autoplayDelay);
    }
    if (previous) previous.addEventListener('click', function () { render(index - 1); restartTimer(); });
    if (next) next.addEventListener('click', function () { render(index + 1); restartTimer(); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { render(Number(dot.dataset.coreDot)); restartTimer(); }); });
    var startX = null;
    carousel.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var delta = event.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) { render(index + (delta < 0 ? 1 : -1)); restartTimer(); }
      startX = null;
    }, { passive: true });
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () { render(index); });
    });
    carousel.addEventListener('mouseenter', pauseTimer);
    carousel.addEventListener('mouseleave', restartTimer);
    carousel.addEventListener('focusin', pauseTimer);
    carousel.addEventListener('focusout', function (event) {
      if (!event.relatedTarget || !carousel.contains(event.relatedTarget)) restartTimer();
    });
    render(index);
    restartTimer();
  }

  function setupMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var menu = document.getElementById('mobile-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      menu.hidden = isOpen;
    });
  }

  function setupLocalNewsletter() {
    var form = document.querySelector('.newsletter-form:not([action])');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var status = form.querySelector('.form-status') || document.createElement('p');
      status.className = 'form-status';
      status.textContent = 'Newsletter connection is TODO — no email was sent.';
      if (!status.parentNode) form.appendChild(status);
    });
  }

  setupHero();
  setupCoreCarousel();
  setupMobileMenu();
  setupLocalNewsletter();
}());
